/* eslint-disable */
//styles
import "../../src/styles/App.css";
import Logo from "../styles/img/header.svg";

//Components
import Header from "../Components/Common/header";

//react
import { useEffect, useState } from "react";

//redux
import { scanToken } from "../lib/slices/paladin";
import { store } from "../lib/store";

//hooks
import RoundLoader from "../Hooks/RoudLoader";

//libs
import { datadogLogs } from "@datadog/browser-logs";
import { MdCancel } from "react-icons/md";

//Components
import InvitationFail from "../Components/InvitationFail";

//Utils
import { getDeviceInfo } from "../Utils/getDeviceInfo";
import { isVerifiedMobileDevice } from "../Utils/deviceValidation";

const App = () => {
  const [loading, setLoading] = useState(false);
  const { dispatch } = store;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const token = urlSearchParams.get("token");
  const [tenantColor, setTenantColor] = useState(localStorage.getItem(`tenantColor_${token}`) || "#6A2ABD");
  const [tenantImage, setTenantImage] = useState(Logo);
  const [tenantName, setTenantName] = useState("");
  const [responseScan, setResponseScan] = useState(null);
  const [deviceInfo, setDeviceInfo] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const device = await getDeviceInfo();
      setDeviceInfo(device);
    };
    loadData();
  }, []);

  // Only allow queryData to run after deviceInfo is loaded
  useEffect(() => {
    if (deviceInfo) {
      queryData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceInfo]);

  const queryData = async () => {
    setLoading(true);
    var data = { token };

    try {
      const response = await dispatch(scanToken({ data }));
      const resolvedColor = response?.payload?.ScanToken?.custom_color || "#6A2ABD";
      setTenantColor(resolvedColor);
      localStorage.setItem(`tenantColor_${token}`, resolvedColor);
      setTenantImage(
        response?.payload?.ScanToken?.custom_image &&
        `data:image/jpeg;base64,${response?.payload?.ScanToken?.custom_image}`
      );
      setTenantName(
        response?.payload?.ScanToken?.account_name
          ? response?.payload?.ScanToken?.account_name
          : ""
      );
      setResponseScan(response?.payload?.ScanToken);
      datadogLogs.logger.log(
        `Token validated (App) with invitation ${response?.payload?.ScanToken?.invitation_id}`,
        {
          category: "token-validation",
          status: "info",
          device: deviceInfo,
          tenantName: response?.payload?.ScanToken?.account_name,
          invitationId: response?.payload?.ScanToken?.invitation_id,
          token: token,
        }
      );
    } catch (error) {
      datadogLogs.logger.log("Error validating token (App) - additional data", {
        category: "error",
        status: "info",
        device: deviceInfo,
        token: token,
        errorMessage: error?.message || error?.toString(),
      });
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <main className="w-full min-h-screen flex flex-col">
        {(!deviceInfo || loading) ? (
          <div className="flex flex-col gap-8 h-screen items-center justify-center w-full container mx-auto p-3 py-6">
            <RoundLoader loading={true} color={tenantColor} />
          </div>
        ) : (
          <>
            {responseScan?.invitation_id && (
              <>
                {isVerifiedMobileDevice() ? (
                  <div className="flex flex-col gap-8 items-center justify-start p-3 pt-9 bg-white flex-1 lg:hidden`">
                    <Header tenantImage={tenantImage} tenantName={tenantName} />
                    <section className="flex flex-col gap-4 items-center justify-center w-full container mx-auto p-5 py-8 pb-9">
                      <h2 className="text-2xl text-center my-3">
                        Complete Your Verification
                      </h2>
                      <p className="text-sm text-center m-0 p-0">
                        You are being asked to verify your identity, review
                        details, or provide additional information. This helps
                        ensure security and protection against identity fraud.
                      </p>
                      <p className="text-sm text-center mt-6">
                        Click continue to securely confirm your details.
                      </p>
                      <button
                        className="shadow-md mt-2 mb-9 rounded-full uppercase w-2/3 font-bold py-2.5"
                        style={{ backgroundColor: tenantColor }}
                        onClick={() =>
                          (window.location.href = `/setup?token=${token}`)
                        }
                      >
                        Continue
                      </button>
                    </section>
                  </div>
                ) : (
                  <div className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
                    <MdCancel size={150} className="text-[#E43122]" />
                    <h2 className="text-2xl text-[#E43122]">Error</h2>
                    <p className="my-5 text-center text-sm">
                      PALIDIN WebID is not available for desktop computers.{" "}
                      <br></br>
                      Please open the authentication invitation on a mobile
                      device.
                    </p>
                  </div>
                )}
              </>
            )}
            {(responseScan?.error || token === null) && <InvitationFail />}
          </>
        )}
      </main>
    </>
  );
};

export default App;
